import common from './common'

const newsletterOnsubmit = {
  ...common.button,
  width: `100%`,
  mb: 3,
  color: `omegaDark`,
  bg: `mute`,
  borderColor: ` mute`,
  cursor: `not-allowed`
}

export default newsletterOnsubmit